// move IconCheckbox
import React, {ReactNode} from "react";
import {Container, Text} from "../../../ui";
import {IconCheckbox} from "../../bounce-ui";

const Label = ({label, children}: {label: string; children?: ReactNode}) => (
  <Container row sx={{justifyContent: "center", height: "40px"}}>
    <Text variant={"inter600"} size={14}>
      {label}
    </Text>
    {children}
  </Container>
);

const CheckboxLabel = ({label}: {label: string}) => (
  <Container row sx={{gap: "4px"}}>
    <IconCheckbox />
    <Text variant={"inter600"} size={12}>
      {label}
    </Text>
  </Container>
);

export {Label, CheckboxLabel};
